import { Payment, PaymentMethod } from '@/api/Cart/cart.interfaces';

export const getDefaultDiscountPaymentMethod = (payment: Payment): PaymentMethod | null => {
    if (!payment.PaymentDiscount) {
        return null;
    }

    const [defaultDiscountPaymentMethod] = payment.PaymentMethods.filter(
        ({ HasDiscount, Discount }) => HasDiscount && Discount
    ).sort((a, b) => {
        const aDiscount = a.Discount?.Amount ?? 0;
        const bDiscount = b.Discount?.Amount ?? 0;
        if (aDiscount < bDiscount) {
            return 1;
        }
        if (aDiscount > bDiscount) {
            return -1;
        }
        return 0;
    });

    return defaultDiscountPaymentMethod;
};
